import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import ProjectList from "@components/ProjectList";

const HomePage = ({ onProjectSelect }) => {
  const navigate = useNavigate();

  const handleProjectSelect = (project) => {
    // Navigate to the project page based on project id or name
    onProjectSelect(project);
    navigate(`/home/${project["name"]}`);
  };

  return (
    <Box
      sx={(theme) => ({
        height: "80vh",
        padding: "20px 10%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        [theme.breakpoints.down("lg")]: {
          height: "76vh",
          minHeight: "76vh",
        },
        [theme.breakpoints.down("md")]: {
          height: "70vh",
          minHeight: "70vh",
        },
      })}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          color: "primary.main",
          marginBottom: "20px",
        }}
      >
        PROJECTS
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          alignItems: "center",
          overflowY: "auto",
          scrollbarColor: "grey transparent",
          padding: "2px",
        }}
      >
        {/* Display the ProjectList component which handles loading and error handling */}
        <ProjectList onSelect={handleProjectSelect} />
      </Box>
    </Box>
  );
};

export default HomePage;
